document.addEventListener('DOMContentLoaded', function() {
    // Show popup on add-to-cart-new click
    document.querySelectorAll('.add-to-cart-new').forEach(function(btn) {
        btn.addEventListener('click', function(e) {
        var popup = document.getElementById('MembershipPopup');
        if (popup) {
            popup.style.display = 'flex';
            e.preventDefault();
        }
        });
    });
    
    // Close popup on close button or overlay click
    var closeBtn = document.getElementById('CloseMembershipPopup');
    var overlay = document.querySelector('.membership-popup__overlay');
    var popup = document.getElementById('MembershipPopup');
    function closePopup() {
        if (popup) popup.style.display = 'none';
    }
    if (closeBtn) closeBtn.addEventListener('click', closePopup);
    if (overlay) overlay.addEventListener('click', closePopup);
    
    // Show popup on specific page and customer tag
    var currentPath = window.location.pathname;
    var customerTags = window.welleasyCustomerTags || {};
    
    if (
        currentPath.endsWith('/pages/lightning-my-aisle') &&
        customerTags.membershipTags &&
        customerTags.membershipTags.includes('inveterate-cancelled')
    ) {
        if (popup) {
        popup.style.display = 'flex';
        }
    }
    });